'use client';
import React from 'react';
import { AlertTriangle, X } from 'lucide-react';
import type { OwnerListing } from './mockOwnerData';

interface Props {
  listing: OwnerListing;
  onConfirm: () => void;
  onCancel: () => void;
}

export default function DeleteConfirmModal({ listing, onConfirm, onCancel }: Props) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/40 backdrop-blur-sm" onClick={onCancel} />
      <div className="relative bg-white rounded-2xl shadow-modal w-full max-w-sm p-6">
        <button onClick={onCancel} className="absolute top-4 left-4 p-1.5 rounded-lg hover:bg-gray-100 transition-colors">
          <X size={16} className="text-gray-500" />
        </button>

        <div className="flex flex-col items-center text-center">
          <div className="w-14 h-14 bg-red-50 rounded-2xl flex items-center justify-center mb-4">
            <AlertTriangle size={24} className="text-red-500" />
          </div>
          <h3 className="font-700 text-gray-900 mb-2">حذف الإعلان</h3>
          <p className="text-sm text-gray-500 mb-1">هل أنت متأكد من حذف هذا الإعلان؟</p>
          <p className="text-sm font-600 text-gray-800 mb-4 px-4 line-clamp-2">"{listing.title}"</p>
          <p className="text-xs text-red-500 bg-red-50 rounded-lg px-3 py-2 mb-5 w-full">
            هذا الإجراء لا يمكن التراجع عنه — سيُحذف الإعلان نهائياً
          </p>

          <div className="flex gap-3 w-full">
            <button
              onClick={onCancel}
              className="flex-1 py-2.5 text-sm font-600 text-gray-600 border border-gray-200 rounded-xl hover:bg-gray-50 transition-colors"
            >
              إلغاء
            </button>
            <button
              onClick={onConfirm}
              className="flex-1 py-2.5 text-sm font-600 text-white bg-red-500 hover:bg-red-600 rounded-xl transition-all active:scale-95"
            >
              نعم، احذف الإعلان
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}